import React from "react";

interface TableRowProps {
  children: React.ReactNode;
  className?: string;
  isHeader?: boolean;
  onClick?: (e: React.MouseEvent<HTMLTableRowElement>) => void;
}

export const TableRow: React.FC<TableRowProps> = ({ 
  onClick,
  children, 
  className = "", 
  isHeader = false 
}) => {
  const baseClasses = isHeader 
    ? "h-12 border-b border-solid border-neutral-border bg-default-background"
    : "border-b border-solid border-neutral-border bg-default-background hover:bg-gray-50";
    
  return (
    <tr className={`${baseClasses} ${className}`} onClick={onClick}>
      {children}
    </tr>
  );
}; 